
import lang from "./lang.js"

export default {
    ...lang
}